export const newsFeedNoResults = `<?xml version="1.0" encoding="UTF-8" ?>
<rss version="2.0">
  <channel>
    <title>TimeLog Help RSS Feed</title>
    <link>http://help.timelog.com/en/feed/</link>
  </channel>
</rss>`;
